/*
 * @Author: 刘小博
 * @Date: 2023-02-17 15:19:10
 * @LastEditTime: 2023-05-18 18:02:42
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\cost-control\cost-settle-accounts\index.js
 * 费用结算管理
 */
import flowSettleAccountsRouter from './modules/flowSettleAccountsRouter'
import shipmentsSettleAccountsRouter from './modules/shipmentsSettleAccountsRouter'
import expenseReportRouter from './modules/expenseReportRouter'
import bussinessTypeRouter from './modules/bussinessTypeRouter'
const costSettleAccountsRouter = [].concat(
  flowSettleAccountsRouter,
  shipmentsSettleAccountsRouter,
  expenseReportRouter,
  bussinessTypeRouter
)

export default costSettleAccountsRouter
